/***********************************
  Download ICS Module
************************************/

Quad.DownloadICS = ( function() {

    // PRIVATE VARS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  
    // PRIVATE METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    function _init() {

        $('.download-ics').each(function(){

        $(this).click(function(e){
            e.preventDefault();

            var startDate   = new Date( $(this).attr('data-start-date') ).toISOString().replace( 'Z', '' ),
                endDate     = new Date( $(this).attr('data-end-date') ).toISOString().replace( 'Z', '' ),
                title       = $(this).attr('data-title'),
                description = $(this).attr('data-description');

            var msg = "BEGIN:VCALENDAR\r\n"+
                      "BEGIN:VEVENT\r\n"+
                      "VERSION:2.0\r\n"+
                      "PRODID:https://www.google.com/\r\n"+
                      "CALSCALE:GREGORIAN\r\n"+
                      "UID:https://www.google.com/\r\n"+
                      "DTSTAMP:"+ startDate +"ZZ\r\n"+
                      "DTSTART;TZID=America/New_York:"+ startDate +"Z\r\n"+
                      "DTEND;TZID=America/New_York:"+ endDate +"Z\r\n"+
                      "LOCATION:Online\r\n"+
                      "SUMMARY:"+ title +"\r\n"+
                      "DESCRIPTION:"+ description +"\r\n"+
                      "END:VEVENT\r\n"+
                      "END:VCALENDAR";

            var uri = 'data:text/calendar;Content-Disposition:attachment;charset=utf8,'+msg;

            // Creates invisible href with custom download name

            var downloadLink          = document.createElement("a");
                downloadLink.href     = uri;
                downloadLink.download = title +".ics";

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);

            // Opens and just sets filename to "download.ics"
            // window.open( uri );
        });

        });

    }
  
    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return { init: _init };
  
  })();
  